<template>
  <transition name="page">
    <div class="prompt-win create-story">
      <div class="inner">
        <p class="title" v-text="titleText"></p>
        <input :type="inputType" v-if="maxLength > 0" :placeholder="placeholder" class="import-name" v-model.trim="note" :maxlength="maxLength" @input="filtration()">
        <input :type="inputType" class="import-name" :placeholder="placeholder" v-model.trim="note" @input="filtration()" v-else>

        <div class="btn-container clearfix">
          <a
            v-for="item in btnConf"
            @click="item.callBack(note)"
            v-text="item.text"
            href="javascript:;"
            class="btn"
          ></a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "prompt_popup",
    props: {
      titleText: String,
      reg: null,
      regStr: null,
      val: null,
      maxLength: Number,
      cancel: Function,
      affirm: Function,
      edit: Function,
      placeholder:String,
      btnConf: Array,
      inputType: {
        type: String,
        default: 'text',
      }
    },
    data() {
      return {
        note: this.val
      }
    },
    methods: {
      filtration() {
        if (this.reg) {
          this.note = this.note.replace(this.reg, this.regStr)
        }
        if (this.inputType === 'number') {
          this.note = parseInt(this.note) > 9999? 9999: parseInt(this.note);
        }
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/org_modal.css";
</style>



// WEBPACK FOOTER //
// src/components/prompt_popup.vue